import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const ListingCheckedLabelCircledIcon = forwardRef(
  ({ size = 40, className = '', ...props }, ref) => (
    <svg
      {...props}
      className={className}
      ref={ref}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
      <circle
        cx="20"
        cy="20.0015"
        r="12.2935"
        stroke={Colors.dark}
        strokeWidth="1.5"
      />
      <path
        d="M25.6523 16.5225L18.5924 22.9906L18.5895 22.9879L18.5867 22.9905L14.7827 19.5054"
        stroke={Colors.dark}
        strokeWidth="1.5"
      />
    </svg>
  )
);

ListingCheckedLabelCircledIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};

export default ListingCheckedLabelCircledIcon;
